var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118,
    height: 118,
    viewBox: "0 0 118 118",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2617",
    "data-name": "Rectangle 2617",
    width: 46.487,
    height: 46.487,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6036",
    "data-name": "Group 6036",
    transform: "translate(-1599 -309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6033",
    "data-name": "Group 6033",
    transform: "translate(558 5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_321",
    "data-name": "Ellipse 321",
    cx: 59,
    cy: 59,
    r: 59,
    transform: "translate(1041 304)",
    fill: "#f1f6ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6035",
    "data-name": "Group 6035",
    transform: "translate(1631.513 346.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6034",
    "data-name": "Group 6034",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7160",
    "data-name": "Path 7160",
    d: "M40.523,34.559h-25l-.411-3.414,26.168-2.053a3.815,3.815,0,0,0,3.457-3.285l.3-2.377a1.623,1.623,0,0,0-3.22-.411l-.3,2.377a.5.5,0,0,1-.5.454l-26.3,2.074-1.88-16.034H23.214a1.621,1.621,0,0,0,0-3.241H12.453l-.238-2.074A5.977,5.977,0,0,0,7.764,1.5L2.016.049A1.616,1.616,0,0,0,.049,1.238,1.616,1.616,0,0,0,1.238,3.2L6.986,4.652A2.7,2.7,0,0,1,9.017,6.964l3.306,28.091a5.972,5.972,0,1,0,7.541,2.788H35.272a6.016,6.016,0,0,0-.67,2.7A5.942,5.942,0,1,0,40.544,34.6ZM17.293,40.5a2.7,2.7,0,1,1-2.7-2.7,2.7,2.7,0,0,1,2.7,2.7m23.229,2.7a2.7,2.7,0,1,1,2.7-2.7,2.7,2.7,0,0,1-2.7,2.7",
    transform: "translate(0 0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7161",
    "data-name": "Path 7161",
    d: "M14.975,12.77l4.257-4.257L14.975,4.256a1.62,1.62,0,0,1,2.291-2.291l4.257,4.257L25.78,1.965A1.62,1.62,0,0,1,28.07,4.256L23.813,8.513,28.07,12.77a1.63,1.63,0,0,1,0,2.291,1.617,1.617,0,0,1-2.291,0L21.523,10.8,17.266,15.06a1.617,1.617,0,0,1-2.291,0,1.63,1.63,0,0,1,0-2.291",
    transform: "translate(16.839 1.737)",
    fill: "#0a64f9"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/emptyCart.c4143a20c1125e808259158748aff843.svg";
export { ForwardRef as ReactComponent };